class Util {
  constructor() {
  }
  static hookWriteBefore() {
    let caseNum = '';
    const userData = window.userData;
    if(userData.accountState.length>0)caseNum = userData.accountState[userData.accountState.length-1].case;
    const isBBSBanned = ()=>{
      //  글쓰기 제재 상태 체크
      let BBSBannedStatus;
      $.ajax({
        type: 'GET',
        url: window._path+'board/writer/is-bbs-banned',
        async:false,
        dataType: 'json',
        contentType: 'application/json',
        xhrFields: {withCredentials: true},
        success: function(data) {
          if( data ) {
            BBSBannedStatus = true;
          } else {
            BBSBannedStatus = false;
          }
        },
        error: function(data) {
          window.alert('잠시 후, 다시 시도해주세요.');
        }
      });
      return BBSBannedStatus;
    }

    if (!userData.isLogin) {
      window.GNBLogin();
      return false; //false 리턴 시 write 페이지로 이동하지 않음
    } else {
      if (isBBSBanned() ||  caseNum == '7' || caseNum == '8' || caseNum == '9') {
        alert('제재된 계정입니다. 자세한 사항은 고객센터로 문의해 주세요.');
        return false;
      } else if (caseNum == '2') {
        alert('본인확인이 필요합니다.');
        return false;
      } else if ( userData.representativeCharacter.name == null) {
        alert('서비스 이용을 위해 대표 캐릭터를 선택해 주세요.');
        return false;
      } else if (userData.representativeCharacter.level < 9) {
        alert('서비스 이용을 위해 9레벨 이상의 대표 캐릭터를 선택해 주세요.');
        return false;
      } else {
        return true; //true 리턴 시 write 페이지로 이동
      }
    }
  }
}
export default Util;